import { render, staticRenderFns } from "./primarydealerfiles.vue?vue&type=template&id=6766c06c&scoped=true&"
import script from "./primarydealerfiles.vue?vue&type=script&lang=js&"
export * from "./primarydealerfiles.vue?vue&type=script&lang=js&"
import style0 from "./primarydealerfiles.vue?vue&type=style&index=0&id=6766c06c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6766c06c",
  null
  
)

export default component.exports